let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gZGeX")).then(() => parcelRequire('8vJyT'));